import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Typography } from '@mui/material';
import { FaUserEdit, FaTools, FaEdit } from 'react-icons/fa';
import UnderConstruction from '../../../components/UnderConstruction';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { useAuthStore } from '../../../auth/state';
import './cont_rev_dashboard.css';

// # Helper function to get display name - moved outside component
const getDisplayName = (userProfile, user) => {
  let name = '';
  let username = '';

  // Get name
  if (userProfile?.lastName) {
    name = `${userProfile.lastName}`;
  } else if (userProfile?.firstName) {
    name = `${userProfile.firstName}`;
  } else {
    name = `${user?.email?.split('@')[0] || 'Reviewer'}`;
  }

  // Get username
  if (userProfile?.username) {
    username = `@${userProfile.username}`;
  }

  return { name, username };
};

// # Helper function to get profile photo URL - moved outside component
const getProfilePhotoUrl = (userProfile) => {
  try {
    if (!userProfile?.photoURL) return '/icons/pfp.png';
    if (userProfile.photoURL === '') return '/icons/pfp.png';
    
    // Check if it's a full URL (from Storage)
    if (userProfile.photoURL.startsWith('http')) {
      return userProfile.photoURL;
    }
    
    // If it's just a filename, assume it's the default
    return '/icons/pfp.png';
  } catch (error) {
    console.error('Error getting profile photo:', error);
    return '/icons/pfp.png';
  }
};

// # Content Reviewer Dashboard component
const ContentReviewerDashboard = () => {
  const navigate = useNavigate();
  const { user, userProfile } = useAuthStore();

  // # Memoize display name to prevent unnecessary recalculations
  const displayName = React.useMemo(() => 
    getDisplayName(userProfile, user), [userProfile, user]);

  return (
    <div className="cnt_rev_dsh_container">
      {/* # Use shared header component */}
      <DashboardHeader />

      {/* # Cover Image */}
      <div className="cnt_rev_dsh_cover-section">
        <img 
          src="/icons/cover_ocean.jpg" 
          alt="Cover" 
          className="cnt_rev_dsh_cover-image"
        />
        
        {/* # Title Logo */}
        <div className="cnt_rev_dsh_title-logo">
          <FaEdit />
          <h1>Content Reviewer Portal</h1>
        </div>
      </div>

      {/* # Profile Section */}
      <div className="cnt_rev_dsh_profile-section">
        <div 
          className="cnt_rev_dsh_profile-image-container"
          onClick={() => navigate('/content-reviewer-dashboard/profile')}
        >
          <img 
            src={getProfilePhotoUrl(userProfile)}
            alt="Profile" 
            className="cnt_rev_dsh_profile-image"
          />
        </div>
        <div className="cnt_rev_dsh_profile-info">
          <h2 className="cnt_rev_dsh_profile-name">
            {displayName.name}
          </h2>
          <div className="cnt_rev_dsh_user_username">
            {displayName.username}
          </div>
        </div>
      </div>
      
      <div className="cnt_rev_dsh_content">
        <Paper className="cnt_rev_dsh_paper">
          <Typography variant="h5" className="cnt_rev_dsh_title">
            <FaUserEdit size={24} /> Content Reviewer Dashboard
          </Typography>
          
          {/* # Use the UnderConstruction component */}
          <UnderConstruction pageName="Content Reviewer Dashboard" />
        </Paper>
      </div>
      
      <DashboardFooter />
    </div>
  );
};

export default ContentReviewerDashboard;
